import React from 'react'

import {makeStyles, Tooltip, CssBaseline, Grid, Typography, CardContent, Paper} from '@material-ui/core';
import CardsHeader from './CardsHeader';
import Cards from './Cards';

import Fab from '@material-ui/core/Fab';


//import ConsultaApiRelacionCtaRut from '../ConsultaApiRelacionCtaRut';



const useStyle = makeStyles( (theme) =>({
    root: {
        flexGrow: 1,
        margin: theme.spacing(3, 4), 
    },
    buttonSuccess: {
        backgroundColor: '#04ba65',
        color: 'white',
        '&:hover': {
            backgroundColor: '#02bf67',
            color: 'white',
        },
    },
    buttonNo: {
        backgroundColor: theme.palette.secondary.main,
        color: 'white',
    },
    paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  },
}));


const InfoVerificacionCheque = () => {

    
    const classes = useStyle();    
    return (  
        <div style={{ width: '100%' }}>
            <CssBaseline />
            
            <Grid container spacing={3} component={Paper}>
            
                <Grid item xs={12} sm={12} md={12} xl={12} lg={12} >
                
                    <CardsHeader titulo="Telas Teresita" rut="76056777-9" giro="Comercializadora de Textiles" direccion="Av.Providencia 333, Santiago." />
                    
                </Grid>


              

                 {/*espacio entre los cuadros*/}
                
                <Grid container  spacing={1} justify="space-around" xs={12} sm={12} md={12} lg={12} xl={12} > 
                    <Grid item  xs={12} sm={12} md={12} lg={2} xl={2} >
                        <Cards  titulo="Banco" dato="Banco de Chile"/>
                    </Grid>
                    <Grid item  xs={12} sm={12} md={3} lg={2} xl={2} >
                        
                        <Cards titulo="Cta Corriente" dato="1293819" />
                    </Grid>
                    <Grid item  xs={12} sm={12} md={3} lg={2} xl={2} >
                    <Cards titulo="Serie" dato="1928392" />
                    </Grid>
                    <Grid item  xs={12} sm={12} md={3} lg={2} xl={2} >
                        <Cards titulo="Monto" dato="192.831" />
                    </Grid>
                    <Grid item  xs={12} sm={12} md={3} lg={2} xl={2} >
                        <Cards titulo="N° Documento" dato="123456" />
                    </Grid>
                    


                </Grid>

                
                <Grid item xs={12} sm={12} md={12} xl={12}>                    
                        {/*<DataTable/>*/}
                        {/*<ConsultaApiRelacionCtaRut/> */ }                                      
                </Grid>


                <Grid container >
                                <Grid item={true} xs={12} md={4} elevation={1} >

                                    <CardContent >
                                        <div align="center">
                                            <Typography align="center">Registro Orden de no Pago</Typography>
                                        </div>
                                        <br />
                                        <div align="center">
                                            <Fab
                                                aria-label="save"
                                                className={classes.buttonNo}
                                                align="center"
                                            >
                                               <Tooltip title="Ver más información">
                                               <Typography variant="h5" align="center" >SI</Typography>
                                                </Tooltip>
                                              
                                            </Fab>
                                            <Typography  align="center" style={{marginTop : '15px'}} ><strong>Motivo: </strong> No especificado </Typography>
                                        </div>
                                    </CardContent>

                                </Grid>

                                <Grid item={true} xs={12} md={4} elevation={1}>

                                    <CardContent>
                                        <div align="center">
                                            <Typography align="center">Registra cta. Corriente Cerrada</Typography>
                                        </div>

                                        <br />
                                        <div align="center">
                                            <Fab
                                                aria-label="save"
                                                className={classes.buttonSuccess}
                                                align="center"
                                            >
                                               <Typography variant="h5" align="center" >NO</Typography>
                                            </Fab>
                                        </div>
                                    </CardContent>

                                </Grid>
                                <Grid item={true} xs={12} md={4} elevation={1} >

                                    <CardContent>
                                        <div align="center">
                                            <Typography align="center">Registra Consulta al Cheque</Typography>

                                        </div>
                                        <br />
                                        <div align="center">
                                        
                                            <Fab
                                                aria-label="save"
                                                className={classes.buttonSuccess}
                                                align="center"
                                            >
                                                <Typography variant="h5" align="center" >SI</Typography>                                                 
                                            </Fab>
                                            <Typography  align="center" style={{marginTop : '15px'}} ><strong>Fecha Ultima Consulta: </strong> 05-10-2020  </Typography>
                                                
                                        </div>
                                    </CardContent>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} sm={12} md={12} xl={12}>
                                {/*<DataTable2/>*/}
                                                     
                            </Grid>
            </Grid>
        </div>
    );
}
 
export default InfoVerificacionCheque;
